import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App as AntApp, ConfigProvider } from 'antd';
import { RouterProvider } from 'react-router-dom';
import { router } from './router.js';
import './styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: (count, error) =>
        !(
          error instanceof Error &&
          'status' in error &&
          (error as { status: number }).status < 500
        ) && count < 2,
    },
  },
});
const container = document.querySelector('#root');
if (container === null) throw new Error('Root element is missing.');
createRoot(container).render(
  <StrictMode>
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#3157d5',
          borderRadius: 10,
          fontFamily: 'Inter, "Segoe UI", sans-serif',
        },
        components: { Layout: { bodyBg: '#f3f5fa', siderBg: '#0b1739', headerBg: '#ffffff' } },
      }}
    >
      <AntApp>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </AntApp>
    </ConfigProvider>
  </StrictMode>,
);
